/**
 * tdesign v1.8.0
 * (c) 2024 tdesign
 * @license MIT
 */

var props = {
  counter: {
    type: Function
  },
  current: {
    type: Number,
    "default": void 0
  },
  modelValue: {
    type: Number,
    "default": void 0
  },
  defaultCurrent: {
    type: Number
  },
  finishButtonProps: {
    type: Object
  },
  hideCounter: Boolean,
  hidePrev: Boolean,
  hideSkip: Boolean,
  highlightPadding: {
    type: Number,
    "default": 8
  },
  mode: {
    type: String,
    "default": "popup",
    validator: function validator(val) {
      if (!val) return true;
      return ["popup", "dialog"].includes(val);
    }
  },
  nextButtonProps: {
    type: Object
  },
  prevButtonProps: {
    type: Object
  },
  showOverlay: {
    type: Boolean,
    "default": true
  },
  skipButtonProps: {
    type: Object
  },
  steps: {
    type: Array
  },
  zIndex: {
    type: Number,
    "default": 999999
  },
  onChange: Function,
  onFinish: Function,
  onNextStepClick: Function,
  onPrevStepClick: Function,
  onSkip: Function
};

export { props as default };
//# sourceMappingURL=props.mjs.map
